export default __webpack_public_path__ + "static/media/Facebook.0e15d585.svg";